/**
 * Le lot du précall du masteur : la route `pre-call`, que « GO ! » pousse avec `liveSessionId`.
 *
 * Inscrite `livesInLive` alors que la route n'existe pas dans la pile du live, comme chez l'élève
 * (`student/LiveEntry/routes.ts`) : c'est pour l'instant où le masteur entre. `setIsLiveModeEnabled`
 * passe le pont en live un rendu AVANT que la pile ne bascule ; une entrée simple remplaçait alors
 * l'écran par l'ancien `PreCallScreen`, qui montait le temps d'un rendu et rouvrait ses sondes. Le même
 * écran reste, puis la pile l'emporte. Chargé à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../../student/loadedOnRender"
import { livesInLive } from "../../student/studentSpaceRouteTypes"
import { type TutorSpaceRouteTable } from "../tutorSpaceRouteTypes"

export const preCallRoutes: TutorSpaceRouteTable<"preCall"> = {
    "pre-call": livesInLive(
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        loadedOnRender(() => require("./TutorPreCallScreen").TutorPreCallScreen, "TutorPreCallScreen")
    ),
}
